import React from 'react'
import { Flex } from 'antd'
import { Color } from '../../../Common/Color'
import News from './News'
import Solution from './Solution'
import Goal from './Goal'
import Consultation from './Consultation'
import MedicalDevices from './MedicalDevices'

export default function ComputerHomePage ({ news }) {
  return (
    <Flex vertical gap='1em' style={{ backgroundColor: Color.white }}>
      <News news={news} />
      <Goal />
      <Solution />
      <MedicalDevices />
      <Consultation />
    </Flex>
  )
}
